import { z } from 'zod'
import { IsoDateTime } from './common'

export const AlertKind = z.enum([
  'new_live_version',
  'run_failed',
  'connector_down',
  'binding_unbound',
  'new_reply_code',
  'retention',
  'info',
])
export type AlertKind = z.infer<typeof AlertKind>

export const Alert = z.object({
  id: z.string(),
  workspaceId: z.string(),
  kind: AlertKind,
  severity: z.enum(['info', 'warning', 'error']),
  title: z.string(),
  message: z.string(),
  link: z.string().nullable().describe('a path inside the portal'),
  createdAt: IsoDateTime,
  acknowledgedAt: IsoDateTime.nullable(),
  acknowledgedBy: z.string().nullable(),
})
export type Alert = z.infer<typeof Alert>

export const AuditEntry = z.object({
  id: z.string(),
  workspaceId: z.string(),
  at: IsoDateTime,
  userId: z.string().nullable().describe('null = the system'),
  action: z.string().describe('e.g. workflow.made_live'),
  entity: z.string(),
  entityId: z.string(),
  summary: z.string(),
})
export type AuditEntry = z.infer<typeof AuditEntry>

export const ApiKey = z.object({
  id: z.string(),
  workspaceId: z.string(),
  name: z.string(),
  hint: z.string(),
  scopes: z.array(z.string()),
  createdAt: IsoDateTime,
  createdBy: z.string(),
  lastUsedAt: IsoDateTime.nullable(),
  revokedAt: IsoDateTime.nullable(),
})
export type ApiKey = z.infer<typeof ApiKey>

export const ApiKeyCreated = z.object({ key: ApiKey, secretShownOnce: z.string() })
export type ApiKeyCreated = z.infer<typeof ApiKeyCreated>

export const NodeTypeSummary = z.object({
  id: z.string(),
  label: z.string(),
  group: z.string(),
  kind: z.enum(['trigger', 'action', 'end']),
  outputs: z.array(z.string()),
})

export const NodePackManifest = z.object({
  id: z.string(),
  name: z.string(),
  version: z.string(),
  description: z.string().default(''),
  nodeTypes: z.array(NodeTypeSummary),
})
export type NodePackManifest = z.infer<typeof NodePackManifest>

export const HomeCounters = z.object({
  liveWorkflows: z.number().int(),
  runsToday: z.number().int(),
  failedToday: z.number().int(),
  connectors: z.number().int(),
  tables: z.number().int(),
  openAlerts: z.number().int(),
})
export type HomeCounters = z.infer<typeof HomeCounters>
